document.addEventListener("DOMContentLoaded", function() {
/* Mini cart — Section Rendering API */

/* ========= Utilities ========= */
async function postJSON(url, data) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return res.json();
}

async function getJSON(url) {
  const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return res.json();
}

/* ========= Section rendering helpers ========= */

// Read the current section ids from the DOM.
// Required: data-section-id on #mini-cart (set in Liquid).
const miniCartEl = document.getElementById('mini-cart');
const MINI_CART_SECTION_ID = miniCartEl?.dataset.sectionId || ''; // e.g., "1234567890abcdef"

// Optional: if you know a header/cart-icon section id, put it on the badge element:
// <span id="mini-cart-item-count" data-section-id="{{ section.id }}"></span>
const cartCountEl = document.getElementById('mini-cart-item-count');
const CART_COUNT_SECTION_ID = cartCountEl?.dataset.sectionId || ''; // optional

// Replace the existing section node with the freshly rendered HTML
function swapSectionHTML(sectionId, html) {
  if (!sectionId || !html) return;

  // Shopify returns the full section HTML (rooted in <section id="shopify-section-...">)
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Try to find the new section root (shopify-section-{id}) in the returned HTML
  // Fallback: first element child
  const newRoot =
    doc.getElementById(`shopify-section-${sectionId}`) ||
    doc.body.firstElementChild;

  if (!newRoot) return;

  const newMiniCart = newRoot.querySelector('#mini-cart');
  if (newMiniCart) {
    newMiniCart.classList.add('open');
  }

  // Find the current section to replace.
  // Prefer #shopify-section-{id}, but also support a custom wrapper with data-section-id
  const current =
    document.getElementById(`shopify-section-${sectionId}`) ||
    document.querySelector(`[data-section-id="${sectionId}"]`);

  if (current && newRoot) {
    current.replaceWith(newRoot);
  }
}

// Fetch one or more sections and swap them into the DOM
async function renderSections(sectionIds = []) {
  const ids = sectionIds.filter(Boolean);
  if (!ids.length) return;

  const url = `/?sections=${ids.join(',')}`;
  const json = await getJSON(url);

  // json is a map: { [sectionId]: "<html>" }
  for (const [id, html] of Object.entries(json)) {
    swapSectionHTML(id, html);
  }
}

// Fallback badge update via /cart.js (works even without header section id)
async function updateCartCountBadgeFromCart() {
  const badge = document.getElementById('mini-cart-item-count');
  if (!badge) return;
  try {
    const cart = await getJSON('/cart.js');

    badge.textContent = String(cart.item_count ?? 0);
  } catch (e) {
    console.error('Failed to update cart count', e);
  }
}

/* ========= UI wiring ========= */

// Toggle mini cart
document.querySelectorAll('.mini-cart-link').forEach(link => {
  link.addEventListener('click', event => {
    event.preventDefault();
    document.getElementById('mini-cart')?.classList.add('open');
    document.body.classList.add('scroll-lock');
  });
});

document.addEventListener('click', (e) => {
  const closeTrigger = e.target.closest('#close-mini-cart, [data-close-mini-cart]');
  if (closeTrigger) {
    e.preventDefault();
    document.getElementById('mini-cart')?.classList.remove('open');
    document.body.classList.remove('scroll-lock');
  }
});

// Event delegation for qty +/- and remove
document.addEventListener('click', async function (e) {
  const target = e.target.closest('.mc-remove-qty, .mc-add-qty, .remove-mini-cart-item');
  if (!target) return;

  // Decrease quantity
  if (target.matches('.mc-remove-qty')) {
    e.preventDefault();
    if (target.closest('#mini-cart')) {
      await update_cart_qty(target.closest('.mc-line-item'), -1);
    } else {
      update_quantity(target.parentElement, -1); // page/cart form flow
    }
    return;
  }

  // Increase quantity
  if (target.matches('.mc-add-qty')) {
    e.preventDefault();
    if (target.closest('#mini-cart')) {
      await update_cart_qty(target.closest('.mc-line-item'), 1);
    } else {
      update_quantity(target.parentElement, 1); // page/cart form flow
    }
    return;
  }

  // Remove item
  if (target.matches('.remove-mini-cart-item')) {
    e.preventDefault();
    const lineItem = target.closest('.mc-line-item');
    const lineKey = lineItem?.dataset.lineKey; // Shopify expects 1-based line index
    if (!lineKey) return;

    try {
      await postJSON('/cart/change.js', { id: lineKey, quantity: 0 });

      // Re-render sections so currency formatting comes from Liquid
      await renderSections([MINI_CART_SECTION_ID /*, CART_COUNT_SECTION_ID */]);

      // Always ensure badge is correct even if we didn't replace its section
      await updateCartCountBadgeFromCart();
    } catch (err) {
      console.error('Remove failed', err);
    }
  }
});

document.addEventListener('click', async function (e) {
  const target = e.target.closest('.mc-remove-qty-pack, .mc-add-qty-pack');
  if (!target) return;

  // Decrease quantity
  if (target.matches('.mc-remove-qty-pack')) {
    e.preventDefault();

    var removeQty = target.dataset.packMultiple;

    if (target.closest('#mini-cart')) {
      await update_cart_qty(target.closest('.mc-line-item'), -removeQty);
    } else {
      update_quantity(target.parentElement, -removeQty); // page/cart form flow
    }
    return;
  }

  // Increase quantity
  if (target.matches('.mc-add-qty-pack')) {
    e.preventDefault();

    var addQty = target.dataset.packMultiple;

    if (target.closest('#mini-cart')) {
      await update_cart_qty(target.closest('.mc-line-item'), addQty);
    } else {
      update_quantity(target.parentElement, addQty); // page/cart form flow
    }
    return;
  }
});

/* ========= Page/cart form quantity helper (unchanged) ========= */

function update_quantity(parent, add_qty) {
  /*const span = parent.querySelector('span');
  if (!span) return;

  let qty = parseInt(span.textContent, 10) || 0;
  qty += add_qty;
  if (qty < 1) qty = 1;

  if (parent.classList.contains('update-cart-quantity')) {
    const line = parent.closest('.cart-item-line');
    if (line) line.classList.add('line-updating');

    const nextInput = parent.nextElementSibling;
    if (nextInput && nextInput.tagName === 'INPUT') {
      nextInput.value = qty;
    }

    const form = parent.closest('form');
    if (form) form.submit();
  } else {
    const form = span.closest('form');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    if (qtyInput) qtyInput.value = qty;
  }

  span.textContent = String(qty);*/
}

/* ========= Mini-cart qty update (via change.js) ========= */

async function update_cart_qty(item, add_qty) {
  if (!item) return;

  const currentQty = item.querySelector('.mc-qty').dataset.qty;
  const qtySpan = item.querySelector('.mc-qty > span');

  let qty = parseInt(currentQty || '0', 10) || 0;
  qty += parseInt(add_qty, 10);
  if (qty < 1) {
    qty = 0;
  }

  const lineKey = item.dataset.lineKey;
  if (!lineKey) return;

  item.querySelector('.mc-qty').dataset.qty = qty;

  // Optimistic UI
  if (qtySpan) {
    const packMultiple = Number(qtySpan.dataset.packMultiple);

    if (packMultiple && !isNaN(packMultiple) && packMultiple !== 0) {
      visibleQty = qty / packMultiple;

      if (visibleQty > 1) {
        qtySpan.textContent = String(visibleQty) + ' packs';
      } else {
        qtySpan.textContent = String(visibleQty) + ' pack';
      }
    } else {
      qtySpan.textContent = String(qty);
    }
  }

  try {
    await postJSON('/cart/change.js', { id: lineKey, quantity: qty });

    await renderSections([MINI_CART_SECTION_ID]);

    await updateCartCountBadgeFromCart();
  } catch (err) {
    console.error('Update qty failed', err);

    await renderSections([MINI_CART_SECTION_ID]);
    await updateCartCountBadgeFromCart();
  }
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add-to-basket');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variantId;
  if (!variantId) return console.error('Missing variant ID.');

  const span = btn.querySelector('span');
  const originalText = span ? span.textContent : btn.textContent;

  btn.disabled = true;
  if (span) span.textContent = 'Adding...';

  const packMultiple = btn.dataset.packMultiple;
  var quantity = 1;

  if (packMultiple && packMultiple > 0) {
    quantity = packMultiple;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: quantity })
  })
  .then(res => res.json())
  .then(() => {
      renderSections([MINI_CART_SECTION_ID /*, CART_COUNT_SECTION_ID */]);
      updateCartCountBadgeFromCart();

      const miniCart = document.querySelector('#mini-cart');
      if (miniCart) {
        miniCart.classList.add('open');
      }
  })
  .catch(err => console.error('Error adding to cart:', err))
  .finally(() => {
    btn.disabled = false;
    if (span) span.textContent = originalText;
  });
});

});